import { faCheck, faCopy } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CopyButton } from 'components/snippet/copy/styled';
import { CopyProps } from 'components/snippet/copy/types';

const Copy = ({ didCopy, onClick, label = 'Copy', successLabel = 'Copied!' }: CopyProps) => {
    return (
        <CopyButton didCopy={didCopy} size="sm" variant="outline" color="neutral" onClick={onClick}>
            <FontAwesomeIcon icon={didCopy ? faCheck : faCopy} />
            {didCopy ? successLabel : label}
        </CopyButton>
    );
};

export { Copy };
